<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ 'MAINTENANCES.REALLOCATE_MAINTENANCE' | translate }} - {{ maintenance.number }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content">
    <mat-tab label="{{ 'MAINTENANCES.GENERAL' | translate }}">
      <tab-general
        [reallocateMaintenancesForm]="reallocateMaintenancesForm"
        [locationAddressCoords]="locationAddressCoords"
      ></tab-general>
    </mat-tab>
  </mat-tab-group>

  <div class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      [disabled]="reallocateMaintenancesForm.invalid || isSaving"
      class="field-background"
      mat-raised-button
      (click)="reallocateMaintenance()"
    >
      {{ 'MAINTENANCES.REALLOCATE' | translate }}
    </button>
  </div>
</div>
